import { useMemo } from "react";

type InputValue = string | number | null | undefined;

/**
 * useMaskedCardNumber
 *
 * یک Hook سفارشی React برای ماسک کردن شماره کارت یا شناسه‌های عددی.
 *
 * - اگر طول عدد 16 باشد، 8 رقم میانی با "*" جایگزین می‌شوند (مثال: 1234********5678)
 * - اگر طول عدد 11 باشد، چهار رقم میانی با "*" جایگزین شده و ترتیب به صورت خاص تغییر می‌کند
 * - در غیر این صورت رشته خالی برگردانده می‌شود
 *
 * @param input شماره کارت یا شناسه ورودی (string | number | null | undefined)
 * @returns رشته ماسک شده
 *
 * @example
 * ```ts
 * const masked = useMaskedCardNumber("1234567812345678");
 * console.log(masked); // "1234********5678"
 * ```
 */
function useMaskedCardNumber(input: InputValue): string {
  const masked = useMemo(() => {
    if (!input) return "";

    const str = String(input).replace(/\D/g, "");

    if (str.length === 16) {
      const start = str.slice(0, 4);
      const end = str.slice(-4);
      const maskedMiddle = "*".repeat(8);
      return `${start}${maskedMiddle}${end}`;
    }

    if (str.length === 11) {
      const start = str.slice(0, 3);
      const middle = "*".repeat(4);
      const end = str.slice(-4);
      return `${end}${middle}${start}`;
    }

    return "";
  }, [input]);

  return masked;
}

export default useMaskedCardNumber;
